<template>
  <v-popover offset="11"
             :open="openPopover"
             trigger="manual"
             open-group="user-role-popover"
             popoverClass="delete-user-popover"
             @hide="openPopover = false">
    <div class="icon-btn" @click="openPopover = true">
      <IconTrash/>
    </div>
    <template slot="popover">
      <div class="col-span-2">
        <div class="text-lg font-bold text-text">
          {{ $t('unlinkUser') }}
        </div>
        <p class="mb-4 text-text text-2sm text-center">
          {{ $t('unlinkUserText', {space_name: current_space.data.title}) }}
        </p>
      </div>
      <div class="actions">
        <BaseButton theme="red"
                    size="sm"
                    :loading="submitted"
                    @click.native="apply">
          {{ $t('apply') }}
        </BaseButton>
        <BaseButton theme="white-red"
                    size="sm"
                    :loading="submitted"
                    v-close-popover>
          {{ $t('cancel') }}
        </BaseButton>
      </div>
    </template>
  </v-popover>
</template>

<script>
import {mapActions, mapState} from "vuex";
import IconTrash from "@/components/icons/IconTrash";
import BaseButton from "@/components/UI/BaseButton";

export default {
  name: "UnlinkUserBtn",
  components: {BaseButton, IconTrash},
  data() {
    return {
      openPopover: false,
      submitted: false
    }
  },
  props: {
    userId: {
      type: Number
    }
  },
  computed: {
    ...mapState('space', ['current_space']),
  },
  methods: {
    ...mapActions('space/access', ['unlinkUserFromSpace', 'fetchSpaceMembers']),
    async apply() {
      try {
        this.submitted = true;
        console.log(this.userId)
        const res = await this.unlinkUserFromSpace(this.userId);
        if (res.body.success) {
          await this.fetchSpaceMembers()
          this.$toasted.success(this.$t('userRemoved'))
        } else {
          console.log(res)
          this.$toasted.error('Ошибка')
        }
      } catch (err) {
        console.error(err)
        this.$toasted.error('Ошибка')
      } finally {
        this.submitted = false;
        this.openPopover = false;
      }
    },
  },
  i18n: {
    messages: {
      en: {
        unlinkUser: 'Remove member',
        unlinkUserText: 'Do you actually want to remove the member?',
        userRemoved:'User removed successfully',
        apply: 'Remove',
        cancel: 'Cancel'
      },
      ru: {
        unlinkUser: 'Удалить участника',
        unlinkUserText: 'Вы действительно хотите удалить участника из совместной бухгалтерии {space_name}?',
        userRemoved:'Пользователь удален',
        apply: 'Удалить',
        cancel: 'Отмена'
      }
    }
  }
}
</script>

<style lang="scss">
.delete-user-popover.tooltip.popover {
  .popover-inner {
    padding: 12px;
    max-width: 29rem;

    .actions {
      @apply grid col-gap-4 justify-center;
      grid-template-columns: repeat(2, 40%);
    }
  }
}
</style>